/**
 * IntelliGems A/B Test: Shipped today (PDP)
 *
 * Control (A): data-shipped-today="false"
 * Variant (B): data-shipped-today="true"
 *
 * Dev preview: ?shipped_today_test=b
 */
(function () {
  'use strict';

  if (window.__shippedTodayABTestInit) return;
  window.__shippedTodayABTestInit = true;

  var BODY_ATTR = 'data-shipped-today';
  var applying = false;
  var debounceTimer = null;
  var variantActive = null;
  var reorderTimer = null;
  var reorderAttempts = 0;

  function isDevVariantB() {
    try {
      return new URLSearchParams(window.location.search).get('shipped_today_test') === 'b';
    } catch (e) {
      return false;
    }
  }

  function isVariantB() {
    if (isDevVariantB()) return true;

    var body = document.body;
    var html = document.documentElement;
    if (!body || !html) return false;

    return body.getAttribute(BODY_ATTR) === 'true' ||
      html.getAttribute(BODY_ATTR) === 'true';
  }

  function findSellingOutFastNode() {
    var host = document.querySelector('.htusb-placeholder-stock');
    if (host && (host.children.length > 0 || host.textContent.trim())) {
      return host;
    }

    var buyButtons = document.querySelector('.ProductForm__BuyButtons');
    if (!buyButtons) return null;

    var nodes = buyButtons.querySelectorAll('[class*="htusb"], [id*="htusb"]');
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i].closest('[data-shipped-today-root]')) {
        return nodes[i];
      }
    }

    return null;
  }

  function reorderPostAtcMessaging() {
    if (!isVariantB()) return;

    var shipped = document.querySelector('[data-shipped-today-root]');
    if (!shipped || shipped.getAttribute('data-show-shipped-today') !== 'true') return;

    var buyButtons = document.querySelector('.ProductForm__BuyButtons');
    if (!buyButtons) return;

    var addToCart = buyButtons.querySelector('.ProductForm__AddToCart');
    var stockNode = findSellingOutFastNode();

    if (addToCart) {
      buyButtons.insertBefore(shipped, addToCart.nextSibling);
    }

    if (stockNode && stockNode !== shipped) {
      buyButtons.insertBefore(stockNode, shipped.nextSibling);
    }
  }

  function scheduleReorder() {
    reorderPostAtcMessaging();

    if (reorderAttempts >= 12) return;
    reorderAttempts += 1;
    reorderTimer = setTimeout(scheduleReorder, 250);
  }

  function resetReorderAttempts() {
    reorderAttempts = 0;
    if (reorderTimer) {
      clearTimeout(reorderTimer);
      reorderTimer = null;
    }
  }

  function applyVariant() {
    if (applying) return;
    applying = true;

    try {
      var variantB = isVariantB();
      if (variantB === variantActive) return;

      variantActive = variantB;
      document.documentElement.classList.toggle('shipped-today-b', variantB);

      if (variantB) {
        resetReorderAttempts();
        scheduleReorder();
      }
    } finally {
      applying = false;
    }
  }

  function syncAvailability(event) {
    var root = document.querySelector('[data-shipped-today-root]');
    if (!root) return;

    var variant = event && event.detail ? event.detail.variant : null;
    var available = variant ? !!variant.available : root.getAttribute('data-show-shipped-today') === 'true';
    var next = available ? 'true' : 'false';

    if (root.getAttribute('data-show-shipped-today') !== next) {
      root.setAttribute('data-show-shipped-today', next);
      if (isVariantB() && next === 'true') {
        resetReorderAttempts();
        scheduleReorder();
      }
    }
  }

  function scheduleApply() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(applyVariant, 40);
  }

  function init() {
    if (isDevVariantB()) {
      if (document.documentElement.getAttribute(BODY_ATTR) !== 'true') {
        document.documentElement.setAttribute(BODY_ATTR, 'true');
      }
      if (document.body && document.body.getAttribute(BODY_ATTR) !== 'true') {
        document.body.setAttribute(BODY_ATTR, 'true');
      }
    }

    applyVariant();
    syncAvailability();

    if (isVariantB()) {
      resetReorderAttempts();
      scheduleReorder();
    }

    document.addEventListener('variant:changed', syncAvailability);

    if (!document.body) return;

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === BODY_ATTR ||
          mutations[i].attributeName === 'data-gem-variant' ||
          mutations[i].attributeName === 'data-gem-test-active') {
          scheduleApply();
          return;
        }
      }
    }).observe(document.body, {
      attributes: true,
      attributeFilter: [BODY_ATTR, 'data-gem-variant', 'data-gem-test-active']
    });

    var stockHost = document.querySelector('.htusb-placeholder-stock');
    if (stockHost && window.MutationObserver) {
      new MutationObserver(function () {
        if (!isVariantB()) return;
        reorderPostAtcMessaging();
      }).observe(stockHost, { childList: true, subtree: true });
    }

    document.addEventListener('gem:variant:changed', scheduleApply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
